import { render, staticRenderFns } from "./FormRespuestas.vue?vue&type=template&id=d31f4ab6&"
import script from "./FormRespuestas.vue?vue&type=script&lang=js&"
export * from "./FormRespuestas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports